import React, { useCallback, useEffect, useState } from 'react';
import { Field } from 'formik';
import { Props } from './LiabilityItem.types';
import { FIELDS } from '../../Form/Form.types';
import styles from './LiabilityItem.module.scss';
import { Fields, Columns } from 'modules/af_cm_ui_kit/components';
import { liabilityTypeDirectorFactory } from '../../../utils/liabilities';
import { DataDirector, LiabilityFormData } from '../../../utils/liabilities/types';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';

const LiabilityItem: React.FC<Props> = ({ item, prefix, onDelete }) => {
  const [creditCommitementDirector, setCreditCommitementDirector] = useState<DataDirector>();
  const getName = (field: FIELDS) => `${prefix}.${field}`;

  useEffect(() => {
    setCreditCommitementDirector(liabilityTypeDirectorFactory(item.type));
  }, [item.type]);

  const shouldShow = useCallback(
    (field: FIELDS) => {
      return creditCommitementDirector ? creditCommitementDirector.getAllowedFields().includes(field) : false;
    },
    [creditCommitementDirector],
  );

  const getTitle = (field: FIELDS) => {
    return creditCommitementDirector ? creditCommitementDirector.getTitle(field as keyof LiabilityFormData) : false;
  };

  const getFields = () => {
    const fields = [];
    if (shouldShow(FIELDS.LIABILITY_AMOUNT))
      fields.push(
        <Field
          component={Fields.Text}
          title={getTitle(FIELDS.LIABILITY_AMOUNT)}
          name={getName(FIELDS.LIABILITY_AMOUNT)}
          variant={VARIANTS_TYPES.CURRENCY}
        />,
      );

    if (shouldShow(FIELDS.LIABILITY_COMMITMENT_END_DATE))
      fields.push(
        <Field
          component={Fields.Text}
          title={getTitle(FIELDS.LIABILITY_COMMITMENT_END_DATE)}
          name={getName(FIELDS.LIABILITY_COMMITMENT_END_DATE)}
          variant={VARIANTS_TYPES.DATE}
        />,
      );

    if (shouldShow(FIELDS.LIABILITY_CREDIT_CARD_BALANCE))
      fields.push(
        <Field
          component={Fields.Text}
          title={getTitle(FIELDS.LIABILITY_CREDIT_CARD_BALANCE)}
          name={getName(FIELDS.LIABILITY_CREDIT_CARD_BALANCE)}
          variant={VARIANTS_TYPES.CURRENCY}
        />,
      );

    if (shouldShow(FIELDS.LIABILITY_IS_CLEARED_BEFORE_LOAN_COMPLETES))
      fields.push(
        <Field
          component={Fields.Checkbox}
          title={getTitle(FIELDS.LIABILITY_IS_CLEARED_BEFORE_LOAN_COMPLETES)}
          name={getName(FIELDS.LIABILITY_IS_CLEARED_BEFORE_LOAN_COMPLETES)}
          required
        />,
      );

    return fields;
  };

  return (
    <>
      <Field type={'hidden'} title={''} name={getName(FIELDS.LIABILITY_TYPE)} />
      <div className={styles.row}>
        <div className="columns">
          <Columns spacing={4}>
            {getFields().map((field, i) => (
              <React.Fragment key={`field-${i}`}>{field}</React.Fragment>
            ))}
          </Columns>
        </div>
        <div className={styles.actions}>
          <button type="button" onClick={onDelete}>
            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1ZM1 16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H11C11.5304 18 12.0391 17.7893 12.4142 17.4142C12.7893 17.0391 13 16.5304 13 16V4H1V16Z"
                fill="#3A4451"
              />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default LiabilityItem;
